import { Flex, Result } from "antd"
import { useTranslation } from "react-i18next"
import { useParams, useSearchParams } from "react-router-dom"
import { Card } from "ui/Card"
import { Text, Title } from "ui/Typography"
import PowerTranzCheckout from "ui/PowerTranzCheckout"
import { spacings } from "themes/variables"
import styles from "./index.module.css"

// Pay page behind a guide-sent PowerTranz payment link (WEB_APP_URL/#/pay/powertranz/<token>).
// PowerTranz has no hosted payment-link product, so the link starts a fresh hosted-page checkout;
// the API verifies the signed token and recomputes the amount, so nothing here can change it.
const PowerTranzPayLink = () => {
  const { t } = useTranslation()
  const { token } = useParams()
  const [searchParams] = useSearchParams()
  // The signed token names the booking (the API's links carry no booking_id); one in the query
  // string is passed along and must match it.
  const bookingId = searchParams.get("booking_id") || undefined

  if (!token) {
    return (
      <Flex className={styles.root} justify="center" align="center">
        <Result status="warning" title={t("powertranz.pay_link.invalid_title")} subTitle={t("powertranz.pay_link.invalid_text")} />
      </Flex>
    )
  }

  return (
    <Flex className={styles.root} justify="center">
      <Card className={styles.card}>
        <Flex vertical gap={spacings.M}>
          <Title level={3}>{t("powertranz.pay_link.title")}</Title>
          <Text>{t("powertranz.pay_link.description")}</Text>
          {/* Keyed by token: opening another link in this tab must not keep the last link's error or attempt. */}
          <PowerTranzCheckout key={token} bookingId={bookingId} linkToken={token} />
        </Flex>
      </Card>
    </Flex>
  )
}

export default PowerTranzPayLink
